import axios from 'axios';
import { TokenManager } from '../plugins/axios-instance';
import Properties from "../properties";

const AUTH_BASE_URL = 'https://karyawan.' + Properties.DOMAIN_URL + '/api';

const fullUserAgent = `AmigoWebApp/1.0.0/${navigator.userAgent}`;

export default class AuthService {
  /**
   * Generate API Key
   */
  static async generateApiKey() {
    try {
      const response = await axios.post(
        `${AUTH_BASE_URL}/admin/auth/generate-api-key`,
        {
          app_name: 'amigoWebApiKey'
        },
        {
          headers: {
            'X-Custom-User-Agent': fullUserAgent,
          }
        }
      );

      const { api_key, expires_at } = response.data.data;
      
      // Store API key and expiry
      TokenManager.setApiKey(api_key);
      TokenManager.setApiKeyExpiry(expires_at);
      
      return response.data;
    } catch (error) {
      console.error('Error generating API key:', error);
      throw error;
    }
  }

  /**
   * Generate Firebase Token using NIK and PIN
   */
  static async generateFirebaseToken(nik, pin) {
    try {
      // Ensure we have a valid API key
      if (!TokenManager.getApiKey() || TokenManager.isApiKeyExpired()) {
        await this.generateApiKey();
      }

      // Create base64 encoded token
      const tokenPayload = { nik, pin };
      const encodedToken = btoa(JSON.stringify(tokenPayload));

      const response = await axios.post(
        `${AUTH_BASE_URL}/firebase/generate-token`,
        {
          token: encodedToken,
          flag: 'web'
        },
        {
          headers: {
            'X-Custom-User-Agent': 'AmigoWebApp/1.0.0/windows',
            'x-api-key': TokenManager.getApiKey()
          }
        }
      );

      const { idToken, refreshToken } = response.data;
      
      // Store tokens
      TokenManager.setIdToken(idToken);
      TokenManager.setRefreshToken(refreshToken);
      
      return response.data;
    } catch (error) {
      console.error('Error generating Firebase token:', error);
      throw error;
    }
  }

  /**
   * Logout - Clear all tokens
   */
  static logout() {
    TokenManager.clearTokens();
    localStorage.removeItem('vue-session-key');
    window.location.href = '/login';
  }

  /**
   * Check if user is authenticated
   */
  static isAuthenticated() {
    const idToken = TokenManager.getIdToken();
    const apiKey = TokenManager.getApiKey();
    
    return !!(idToken && apiKey && !TokenManager.isApiKeyExpired());
  }

  /**
   * Get current authentication status
   */
  static getAuthStatus() {
    return {
      hasApiKey: !!TokenManager.getApiKey(),
      hasIdToken: !!TokenManager.getIdToken(),
      hasRefreshToken: !!TokenManager.getRefreshToken(),
      isApiKeyExpired: TokenManager.isApiKeyExpired(),
      isAuthenticated: this.isAuthenticated()
    };
  }
}
